export default "__VITE_ASSET__BrJBK68p__"